export const products = [
  {
    id: "p1",
    name: "Industrial LED Smart Panel 200W",
    supplierId: "s1",
    supplierName: "Al Futtaim Industrial Group",
    category: "Electronics",
    country: "UAE",
    city: "Dubai",
    price: { min: 45, max: 120 },
    moq: 50,
    dropshipping: true,
    verified: true,
    rating: 4.8,
    reviews: 342,
    image: "https://public.readdy.ai/ai/img_res/ba4610db10aa78dce53b022134705107.jpg",
  },
  {
    id: "p2",
    name: "Premium Arabic Thobe Fabric Roll",
    supplierId: "s2",
    supplierName: "Saudi Star Manufacturing Co.",
    category: "Textiles",
    country: "Saudi Arabia",
    city: "Riyadh",
    price: { min: 8, max: 25 },
    moq: 100,
    dropshipping: false,
    verified: true,
    rating: 4.9,
    reviews: 218,
    image: "https://readdy.ai/api/search-image?query=premium%20white%20Arabic%20thobe%20fabric%20roll%20textile%20material%20clean%20white%20background%20product%20photography%20luxury&width=400&height=400&seq=prod2&orientation=squarish",
  },
  {
    id: "p3",
    name: "Food-Grade Packaging Containers Set",
    supplierId: "s3",
    supplierName: "Qatar Premium Exports LLC",
    category: "Packaging",
    country: "Qatar",
    city: "Doha",
    price: { min: 2, max: 8 },
    moq: 500,
    dropshipping: true,
    verified: true,
    rating: 4.7,
    reviews: 156,
    image: "https://readdy.ai/api/search-image?query=food%20grade%20packaging%20containers%20set%20clear%20plastic%20white%20background%20product%20photography%20professional%20clean%20minimal&width=400&height=400&seq=prod3&orientation=squarish",
  },
  {
    id: "p4",
    name: "Smart Home Security Camera 4K",
    supplierId: "s4",
    supplierName: "Dubai Tech Solutions FZE",
    category: "Electronics",
    country: "UAE",
    city: "Dubai",
    price: { min: 35, max: 95 },
    moq: 10,
    dropshipping: true,
    verified: true,
    rating: 4.9,
    reviews: 891,
    image: "https://readdy.ai/api/search-image?query=smart%20home%20security%20camera%204K%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech&width=400&height=400&seq=prod4&orientation=squarish",
  },
  {
    id: "p5",
    name: "Custom Sports Uniform Set",
    supplierId: "s5",
    supplierName: "Jeddah Garment Factory",
    category: "Clothing",
    country: "Saudi Arabia",
    city: "Jeddah",
    price: { min: 12, max: 35 },
    moq: 20,
    dropshipping: true,
    verified: false,
    rating: 4.3,
    reviews: 67,
    image: "https://readdy.ai/api/search-image?query=custom%20sports%20uniform%20set%20jersey%20shorts%20professional%20athletic%20wear%20white%20background%20product%20photography%20clean&width=400&height=400&seq=prod5&orientation=squarish",
  },
  {
    id: "p6",
    name: "Stainless Steel Structural Beams",
    supplierId: "s6",
    supplierName: "Doha Steel & Metal Works",
    category: "Steel",
    country: "Qatar",
    city: "Doha",
    price: { min: 180, max: 450 },
    moq: 5,
    dropshipping: false,
    verified: true,
    rating: 4.6,
    reviews: 43,
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20structural%20beams%20industrial%20metal%20construction%20material%20white%20background%20product%20photography%20professional&width=400&height=400&seq=prod6&orientation=squarish",
  },
  {
    id: "p7",
    name: "Wireless Bluetooth Earbuds Pro",
    supplierId: "s4",
    supplierName: "Dubai Tech Solutions FZE",
    category: "Electronics",
    country: "UAE",
    city: "Dubai",
    price: { min: 18, max: 55 },
    moq: 30,
    dropshipping: true,
    verified: true,
    rating: 4.8,
    reviews: 1204,
    image: "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20pro%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20audio%20tech&width=400&height=400&seq=prod7&orientation=squarish",
  },
  {
    id: "p8",
    name: "Luxury Arabic Oud Perfume 100ml",
    supplierId: "s1",
    supplierName: "Al Futtaim Industrial Group",
    category: "Beauty",
    country: "UAE",
    city: "Dubai",
    price: { min: 25, max: 80 },
    moq: 24,
    dropshipping: true,
    verified: true,
    rating: 4.9,
    reviews: 567,
    image: "https://readdy.ai/api/search-image?query=luxury%20Arabic%20oud%20perfume%20bottle%20100ml%20gold%20elegant%20design%20white%20background%20product%20photography%20premium%20fragrance&width=400&height=400&seq=prod8&orientation=squarish",
  },
  {
    id: "p9",
    name: "Handwoven Persian Carpet 3x5m",
    supplierId: "s2",
    supplierName: "Saudi Star Manufacturing Co.",
    category: "Home Decor",
    country: "Saudi Arabia",
    city: "Riyadh",
    price: { min: 320, max: 850 },
    moq: 1,
    dropshipping: false,
    verified: true,
    rating: 4.9,
    reviews: 89,
    image: "https://readdy.ai/api/search-image?query=handwoven%20Persian%20carpet%203x5m%20luxury%20traditional%20pattern%20gold%20red%20white%20background%20product%20photography%20premium&width=400&height=400&seq=prod9&orientation=squarish",
  },
];

export const categories = [
  { name: "Electronics", icon: "ri-cpu-line", count: 45200 },
  { name: "Textiles & Fabric", icon: "ri-scissors-line", count: 28900 },
  { name: "Machinery", icon: "ri-settings-3-line", count: 19400 },
  { name: "Food & Beverage", icon: "ri-restaurant-line", count: 15600 },
  { name: "Furniture", icon: "ri-sofa-line", count: 12300 },
  { name: "Auto Parts", icon: "ri-car-line", count: 9800 },
  { name: "Beauty & Care", icon: "ri-sparkling-line", count: 8700 },
  { name: "Construction", icon: "ri-building-line", count: 7400 },
];
